import Vue from 'vue'

// "async" is optional;
// more info on params: https://quasar.dev/quasar-cli/boot-files
export default async (/* { app, router, Vue ... } */) => {
  // something to do
}

const rules = {
  required: (v) => !!v || 'Este campo es requerido',
  email: (v) => v === undefined || v === null || v === '' || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'El e-mail es invalido',
}

Vue.prototype.$rules = rules
